import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import { useNavigate } from "react-router";
import SpedyCard from "../../../components/apps/spedy/SpedyCard";

export default function Spedy() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Spedy"
                description="Spedy"
            />
            <PageBreadcrumb
                pageTitle="Spedy"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <SpedyCard />
                </div>
            </div>
        </>
    );
}
